import React from "react"
import { Link } from "gatsby"

const AboutBlurb = () => {
  return (
    <React.Fragment>
      <p>
        Sponsorship marketing is a cost-effective method for companies to
        advertise their goods and services to targeted, engaged audiences.{" "}
        <strong>Looking For Sponsor</strong> was created to connect people
        looking for sponsorships with the companies looking to sponsor them.
      </p>
      <p>
        Social media influencers, YouTubers, streamers, podcasts, esports teams,
        nonprofits, and school clubs post their sponsorship opportunities on our
        website, where companies can discover them and contribute sponsorship
        money.
      </p>
      <p>
        Although we regularly <Link to="/featured">feature</Link> sponsorship
        opportunities, you can find even more opportunities (and post your own)
        by signing up. It's 100% free to browse our opportunities --{" "}
        <Link
          to="/app/signup"
          state={{
            signupPayload: null,
          }}
        >
          {" "}
          sign up today!{" "}
        </Link>
      </p>
      <br />
    </React.Fragment>
  )
}

export default AboutBlurb
